var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgActivityVisitor(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 14,
    viewBox: "0 0 18 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.01677 7.59171C0.90328 7.41201 0.846535 7.32216 0.81477 7.18358C0.79091 7.07948 0.79091 6.91531 0.81477 6.81122C0.846535 6.67263 0.90328 6.58278 1.01677 6.40308C1.95461 4.9181 4.74617 1.16406 9.00034 1.16406C13.2545 1.16406 16.0461 4.9181 16.9839 6.40308C17.0974 6.58278 17.1541 6.67263 17.1859 6.81122C17.2098 6.91531 17.2098 7.07948 17.1859 7.18358C17.1541 7.32216 17.0974 7.41201 16.9839 7.59171C16.0461 9.0767 13.2545 12.8307 9.00034 12.8307C4.74617 12.8307 1.95461 9.0767 1.01677 7.59171Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.00034 9.4974C10.381 9.4974 11.5003 8.37811 11.5003 6.9974C11.5003 5.61668 10.381 4.4974 9.00034 4.4974C7.61962 4.4974 6.50034 5.61668 6.50034 6.9974C6.50034 8.37811 7.61962 9.4974 9.00034 9.4974Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActivityVisitor);
export default __webpack_public_path__ + "static/media/activity-visitor.f3f0b5b3b58a0651b8d6270bc088ddf4.svg";
export { ForwardRef as ReactComponent };